import { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { distances } from '@setvi/shared/styles';
import {
  Box,
  TextField,
  InputAdornment,
  TextFieldProps
} from '@material-ui/core';
import clsx from 'clsx';
import SLabel from '../slabel';

const useStyles = makeStyles(({ palette }) => ({
  paperBox: {
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: distances.px.small,
    backgroundColor: palette.common.white
  },
  paperBoxNewDesign: {
    backgroundColor: 'transparent',
    marginBottom: 0
  },
  title: {
    marginBottom: distances.px.small
  },
  required: {
    color: '#d72638'
  },
  inputWrapper: {
    boxShadow: 'none',
    position: 'relative'
  },
  input: {
    marginBottom: distances.px.large,
    '& .MuiOutlinedInput-root': {
      height: 45
    }
  },
  inputNewDesign: {
    marginBottom: distances.px.medium,

    '& .MuiOutlinedInput-root': {
      height: 45,
      backgroundColor: 'transparent',
      borderRadius: 8,
      transition: 'background-color 0.2s ease-in-out',
      '& fieldset': {
        borderRadius: 8
      },
      '&.Mui-focused': {
        backgroundColor: palette.common.white
      },
      '&:focus-within': {
        backgroundColor: palette.common.white
      },
      '&.Mui-disabled': {
        backgroundColor: '#EEF0F2',
        '& fieldset': {
          borderColor: '#E8ECEE'
        },
        '& .MuiInputBase-input': {
          color: '#B3B3B3',
          WebkitTextFillColor: '#B3B3B3'
        }
      }
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#5D7083',
      opacity: 1
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#5D7083',
      opacity: 1
    },
    '& .MuiInputBase-input::-moz-placeholder': {
      color: '#5D7083',
      opacity: 1
    }
  },
  error: {
    color: palette.error.main,
    fontSize: '14px',
    marginTop: distances.px.xsmall,
    textAlign: 'right'
  },
  multiline: {
    '& .MuiInputBase-input': {
      alignSelf: 'flex-start'
    }
  }
}));

export type FormikTextfieldProps = {
  labelClass?: string;
  endIcon?: JSX.Element;
  startIcon?: JSX.Element;
  containerStyle?: React.CSSProperties;
  newDesign?: boolean;
} & TextFieldProps;

const SInput: FC<FormikTextfieldProps> = ({
  name,
  required,
  className,
  label,
  labelClass,
  endIcon,
  startIcon,
  variant = 'outlined',
  containerStyle,
  newDesign,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Box
      className={clsx(classes.paperBox, {
        [classes.paperBoxNewDesign]: newDesign
      })}
      key={name}
      style={containerStyle}>
      {(label || required) && (
        <SLabel
          title={label}
          style={
            newDesign
              ? {
                  color: rest.disabled ? '#AFBAC6' : '#333D47'
                }
              : {}
          }
          className={clsx(labelClass, classes.title)}
          variant="body2"
          required={required}
        />
      )}

      <Box className={classes.inputWrapper}>
        <TextField
          className={clsx(classes.input, className, {
            [classes.inputNewDesign]: newDesign
          })}
          InputProps={{
            startAdornment: startIcon && (
              <InputAdornment position="start">{startIcon}</InputAdornment>
            ),
            endAdornment: endIcon && (
              <InputAdornment position="start">{endIcon}</InputAdornment>
            )
          }}
          variant={variant}
          {...rest}
        />
      </Box>
    </Box>
  );
};

export default SInput;
